var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdMarine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#A0FFE4",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M5.53 9.4c-.25.01-.47.21-.52.49-.05.28.07.56.29.69 0 0 1.14.68 2.4.68 1.04 0 1.86-.41 2.15-.57.29.16 1.11.57 2.15.57 1.05 0 1.87-.41 2.16-.57.29.16 1.1.57 2.15.57 1.26 0 2.39-.68 2.39-.68a.63.63 0 0 0 .3-.52.65.65 0 0 0-.24-.55.48.48 0 0 0-.54-.04s-1.01.55-1.91.55-1.91-.55-1.91-.55a.48.48 0 0 0-.48 0s-1.02.55-1.92.55-1.91-.55-1.91-.55a.48.48 0 0 0-.48 0s-1.01.55-1.91.55-1.91-.55-1.91-.55a.48.48 0 0 0-.26-.07zM5.6 12.91c-.25.01-.47.21-.52.49-.05.28.07.56.29.69 0 0 1.14.68 2.4.68 1.04 0 1.86-.41 2.15-.57.29.16 1.11.57 2.15.57 1.05 0 1.87-.41 2.16-.57.29.16 1.1.57 2.15.57 1.26 0 2.39-.68 2.39-.68a.63.63 0 0 0 .3-.52.65.65 0 0 0-.24-.55.48.48 0 0 0-.54-.04s-1.01.55-1.91.55-1.91-.55-1.91-.55a.48.48 0 0 0-.48 0s-1.02.55-1.92.55-1.91-.55-1.91-.55a.48.48 0 0 0-.48 0s-1.01.55-1.91.55-1.91-.55-1.91-.55a.48.48 0 0 0-.26-.07z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdMarine);
export default __webpack_public_path__ + "static/media/icon-pd-marine.fa8f524d0d272ef844edb993d44434c6.svg";
export { ForwardRef as ReactComponent };